// Confirmation + mutation for a member revoking their own access. Shared by the
// My Access row's inline Revoke button and the grant drawer's footer. The caller
// owns the mutation state so it can disable its button while the removal runs.

import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import ConfirmModal from "components/ds/ConfirmModal";
import { MF_ACCESS } from "state/members/access_v2/catalogs";
import { revokedToastTitle } from "./revokeAction";

export const useRevokeAccessFlow = (
  accessId: string,
  itemName: string,
  onRevoked?: () => void,
) => {
  const toast = useToast();
  const {
    mutate: revoke,
    isLoading: revoking,
    isSubmitting: submitting,
  } = MF_ACCESS.useRevokeAccess(accessId);
  const [confirming, setConfirming] = useState(false);

  // Errors are already toasted by useMemberMutate.
  const doRevoke = () => {
    setConfirming(false);
    revoke()
      .then((status) => {
        toast({
          status: "success",
          variant: "subtle",
          title: revokedToastTitle(status),
        });
        onRevoked?.();
      })
      .catch(() => undefined);
  };

  const confirmModal = confirming ? (
    <ConfirmModal
      title="Revoke this access?"
      body={`You'll lose access to ${itemName}. You can request it again later.`}
      confirmLabel="Revoke access"
      cancelLabel="Keep access"
      confirmTone="danger"
      onConfirm={doRevoke}
      onCancel={() => setConfirming(false)}
    />
  ) : null;

  return {
    revoking,
    submitting,
    confirming,
    askToRevoke: () => setConfirming(true),
    confirmModal,
  };
};
